import { useTranslation } from 'react-i18next';

import { CurrencyCode } from '@/helpers/currency';
import { Locale } from '@/helpers/languages';
import { useGetCommonStore } from '@/store';

export const MAP_LOCALE_TO_CURRENCY: Record<string, CurrencyCode | null> = {
  [Locale.ENGLISH_NEW_ZEALAND]: CurrencyCode.AUD,
  [Locale.GERMAN]: CurrencyCode.EUR,
  [Locale.FRENCH_SWITZERLAND]: CurrencyCode.EUR,
  [Locale.NORWEGIAN]: CurrencyCode.EUR,
  [Locale.ENGLISH_IRELAND]: CurrencyCode.EUR,
  [Locale.ENGLISH]: null,
  [Locale.FRENCH_CANADA]: CurrencyCode.CAD,
  [Locale.ENGLISH_CANADA]: CurrencyCode.CAD,
  [Locale.ENGLISH_AUSTRALIA]: CurrencyCode.AUD,
};

export const MAP_CURRENCY_TO_CURRENCY: Record<string, CurrencyCode | null> = {
  [CurrencyCode.AUD]: CurrencyCode.AUD,
  [CurrencyCode.EUR]: CurrencyCode.EUR,
  [CurrencyCode.CAD]: CurrencyCode.CAD,
  [CurrencyCode.NOK]: CurrencyCode.EUR,
  [CurrencyCode.USD]: null,
  [CurrencyCode.ZAR]: null,
  [CurrencyCode.NZD]: CurrencyCode.AUD,
};

export const useUserCurrency = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();
  const currentWallet = useCommonStore.use.currentWallet();

  let currency: CurrencyCode | null = null;

  if (!(isAuthenticated && currentWallet) || currentWallet.isCrypto) {
    currency = MAP_LOCALE_TO_CURRENCY[language];
  } else {
    currency = MAP_CURRENCY_TO_CURRENCY[currentWallet.currency];
  }

  return { isLoading: pendingUser, currency };
};
